import React from "react";
import styled from "styled-components";
import { Footer } from "./Footer";
import { Header } from "./Header";

type Props = {
  invertHeader?: boolean;
};

export const Layout: React.FC<Props> = ({ invertHeader = false, children }) => (
  <StyledLayout>
    <Header invertHeader={invertHeader} />
    {children}
    <Footer />
  </StyledLayout>
);

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  main {
    flex: 1 1 auto;
  }
`;
